export default "__VITE_ASSET__F$vQNaQW__ 600w";